var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('Banner'),_c('Mapcomponent',{attrs:{"mapdata":_vm.data1}}),_c('Gmap'),_c('Screenshots')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }